var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("top"),_c('sidebar-menu',{staticClass:"shrinkable-menu",attrs:{"menu-list":_vm.menuList,"openeds":_vm.openeds,"collapse":_vm.collapse},on:{"on-change":_vm.handleChange}}),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }